(() => {
  if (window.packagingCartInit) return;
  window.packagingCartInit = true;

  const BUTTON_SELECTOR = ".packaging-add-btn";
  const DEFAULT_LABEL = "Add";
  const SUCCESS_LABEL = "Adicionado!";

  function getButtonLabel(button) {
    return button.querySelector(".hidden-on-load");
  }

  function setFeedback(button, message, type = "error") {
    const container = button
      .closest(".quick-add-form")
      ?.querySelector(".packaging-feedback");

    if (!container) return;

    container.textContent = message;
    container.dataset.type = type;
    container.hidden = !message;
  }

  function setLoading(button, loading) {
    button.classList.toggle("loading", loading);
    button.disabled = loading;
  }

  function showToast(message, type) {
    let toast = document.querySelector(".packaging-toast");

    if (!toast) {
      toast = document.createElement("div");
      toast.className = "packaging-toast";
      toast.setAttribute("role", type === "error" ? "alert" : "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }

    window.clearTimeout(toast.hideTimer);
    toast.dataset.type = type;
    toast.textContent = message;
    toast.classList.add("is-visible");
    toast.hideTimer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 4000);
  }

  function getCartSections(cartDrawer) {
    if (!cartDrawer) return [];

    if (typeof cartDrawer.getSectionsToRender === "function") {
      return [
        ...new Set(
          cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
            .filter(Boolean),
        ),
      ];
    }

    const sectionId = cartDrawer.getAttribute("data-section-id");
    return sectionId ? [sectionId, "cart-icon-bubble"] : [];
  }

  function showSuccess(button, variantId, duration = 4000) {
    const currentButton =
      document.querySelector(
        `${BUTTON_SELECTOR}[data-variant-id="${CSS.escape(variantId)}"]`,
      ) || button;
    const label = getButtonLabel(currentButton);

    currentButton.classList.remove("loading");
    currentButton.disabled = true;
    if (label) label.textContent = SUCCESS_LABEL;
    setFeedback(currentButton, "Produto adicionado à sacola.", "success");
    showToast("Produto adicionado à sacola.", "success");

    window.setTimeout(() => {
      const latestButton =
        document.querySelector(
          `${BUTTON_SELECTOR}[data-variant-id="${CSS.escape(variantId)}"]`,
        ) || currentButton;
      const latestLabel = getButtonLabel(latestButton);

      if (latestLabel) latestLabel.textContent = DEFAULT_LABEL;
      latestButton.disabled = false;
      setFeedback(latestButton, "");
    }, duration);
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const quantity = Number.parseInt(button.dataset.quantity || "1", 10);

    if (!variantId) {
      setFeedback(button, "Não foi possível identificar este produto.");
      showToast("Não foi possível identificar este produto.", "error");
      return;
    }

    setFeedback(button, "");
    setLoading(button, true);

    try {
      const cartDrawer = document.querySelector("cart-drawer");
      const sections = getCartSections(cartDrawer);
      const payload = {
        items: [{ id: Number.parseInt(variantId, 10), quantity }],
      };

      if (sections.length) {
        payload.sections = sections.join(",");
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(
        window.routes?.cart_add_url || "/cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description || data.message || "Não foi possível adicionar o produto.",
        );
      }

      showSuccess(button, variantId);

      if (
        data.sections &&
        cartDrawer &&
        typeof cartDrawer.renderContents === "function"
      ) {
        window.setTimeout(() => {
          cartDrawer.renderContents(data);
          showSuccess(button, variantId, 3000);
        }, 700);
      }

      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: { cart: data } }),
      );
    } catch (error) {
      setLoading(button, false);
      const label = getButtonLabel(button);
      if (label) label.textContent = DEFAULT_LABEL;
      setFeedback(
        button,
        error.message || "Não foi possível adicionar o produto à sacola.",
      );
      showToast(
        error.message || "Não foi possível adicionar o produto à sacola.",
        "error",
      );
    }
  });
})();
